import React from 'react';
import Modal, {
  CONTENT_POSITION,
  OPACITY_LAYOUT_COLORS,
  IN_SCENE_EFFECT,
  OUT_SCENE_EFFECT,
} from '@bit/gerenciatd.unifiedcomponents.modal';
import SvgIconLoader, { SVG_ICON_KIND } from '@bit/gerenciatd.unifiedicons.svg-icon-loader';
import TextInfo, {
  COLOR,
  SEGMENT,
  FONT_TYPE,
  SIZE,
  KIND_TEXT,
} from '@bit/gerenciatd.unifiedcomponents.text-info';
import CustomLink from '@bit/gerenciatd.unifiedcomponents.custom-link';

import VideoFrame from '../Video';

import './PlayVideo.scss';

export const COMPONENT_NAME = 'Video';

const PlayVideo = ({
  img, video, height, children, width, bucleVideo, urlVideo, playIcon, imgDesktop,
}) => {
  /**
   * Asigna las propiedades al modal
   */
  const setUpModalProps = () => {
    Modal.setModalProps({
      contentPosition: CONTENT_POSITION.CENTER_CENTER,
      opacityLayoutColor: OPACITY_LAYOUT_COLORS.BLACK05,
      inSceneEffect: IN_SCENE_EFFECT.FADE_IN_RIGHT,
      outSceneEffect: OUT_SCENE_EFFECT.FADE_OUT_RIGHT,
      closeByClickingOutside: true,
      scrollAllowed: true,
    });
  };

  const handleModal = () => {
    setUpModalProps();
    Modal.setContent(
      <VideoFrame urlVideo={urlVideo} />
    );
    return Modal.show();
  };

  return (
    <div className="PlayVideo">
      <div className={`PlayVideo__wrapper  width-${width}`}>
        <div className={`background-video-2 background-video-2__${height} width-${width}`}>
          {
              bucleVideo
                ? (
                  <video autoPlay loop muted playsinline data-wf-ignore="true" data-object-fit="cover">
                    <source src={bucleVideo} data-wf-ignore="true" />
                  </video>
                ) : (
                  <img
                    src={`https://www.movistar.es${imgDesktop}`}
                    alt="Imagen"
                  />
                )
          }
          {children}
          {
            playIcon
            && (
            <CustomLink
              taggingInfo={{
                componentContent: 'play',
                componentProduct: '',
                componentVariation: 'all',
                componentName: COMPONENT_NAME,
              }}
              onClick={handleModal}
              className="play"
            >
              <SvgIconLoader
                kind={SVG_ICON_KIND.MEDIUM}
                segment={SEGMENT.EMP}
                backgroundColor={COLOR.TRANSPARENT}
                size={41}
                id="Play"
                color={COLOR.WHITE}
                tabletProps={{
                  size: 81,
                }}
              />
              <TextInfo
                kind={KIND_TEXT.PARAGRAPH}
                size={SIZE.TITLE5}
                fontType={FONT_TYPE.LIGHT}
                align="center"
                color={COLOR.WHITE}
                text="Ver video"
                segment={SEGMENT.EMP}
                className="margin-top"
              />
            </CustomLink>
            )
          }
        </div>
      </div>
    </div>
  );
};

export default PlayVideo;
